import { DownOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Dropdown,
  Form,
  Modal,
  notification,
  Radio,
  Space,
  Table,
} from "antd";
import  { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../utils/axios";
import { useLoader } from "../../../../context/LoaderContext";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../../../../i18n";
import { addApprenantsToSessionHomologuee, deleteParticipant, generationAttestaionPresence, getListeDemandeurs } from "../../../../api/geoprod";
import GlobalContext from "../../../../context/GlobalContext";
import { CircleArrowLeft } from "lucide-react";
import classes from "../../../Etablissements/Etablissements.module.css";
const ListeApprenants = () => {
  const [data, setData] = useState([]);
  const params = useLocation();
  const idDemande = params?.state?.idSession;
  const check_disabled_btn_add_apprenant = params?.state?.check_disabled_btn_add_apprenant;
  const [modalVisible, setModalVisible] = useState(false);
  const [demandeurs, setDemandeurs] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [attestationModalVisible, setAttestationModalVisible] = useState(false);
  const [selectedApprenant, setSelectedApprenant] = useState(null);
  const {form} = useContext(GlobalContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
     const [visibleModalDelete, setVisibleModalDelete] = useState(false);
  const { setIsLoading } = useLoader();
  const consulterPreInscrit = (record, type) => {
    navigate("/pre-inscrit/" + record?.id_formation, {
      state: {
        type: type,
        id_apprenant: record.id,
        id_specialite: record?.data_from?.id_specialite,
      },
    });
  };
   const handleDemanderAttestation = (record) => {
    setSelectedApprenant(record);
    setAttestationModalVisible(true);
  };
    const showDeleteConfirm = (record) => {
    setSelectedApprenant(record);
    setVisibleModalDelete(true);
  };
 const handleDeleteParticipant = async () => {
   if (!selectedApprenant) return;
  setIsLoading(true)
      await deleteParticipant(selectedApprenant?.id, selectedApprenant?.id_formation).then((response)=>
      {
         notification.success({
            message: t("Succès"),
            description: t(response?.message),
            duration: 0,
          });
           setRefresh(!refresh);
          setIsLoading(false)
            setVisibleModalDelete(false);
        setSelectedApprenant(null);
      }
    )
      .catch((error)=>{
         notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message),
            duration: 0,
          });
          setIsLoading(false)
      })
  };
 const handleGenererAttestation = () => {
  form.validateFields()
    .then((values) => {
      setIsLoading(true);
      generationAttestaionPresence({
        // id_apprenant: 554,
        id_apprenant:selectedApprenant?.id,
        langue: values?.langue
      })
        .then((response) => {
            if (values?.langue === "fr" && response?.message?.url_fr)
            {
            setIsLoading(false)
            window.open(response?.message?.url_fr, '_blank');
            setAttestationModalVisible(false);
            form.resetFields();
            }
            else
            {
            setIsLoading(false)
            window.open(response?.message?.url_ar, '_blank');
            setAttestationModalVisible(false);
            form.resetFields();
            }
        })
        .catch((error) => {
      setIsLoading(false)

          notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message) || t("La requête n’a pas pu aboutir. Une alerte a été transmise à notre équipe technique qui s’en occupe déjà. Merci de réessayer un peu plus tard."),
        })
        
    })})
    .catch(() => {
      setIsLoading(false)
        // notification.error({
        //   message: t("Erreur"),
        //   description: t("Veuillez vérifier tous les champs."),
        // });
    });
};
  const role = localStorage.getItem("role");
  const columns = [
    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) =>
        i18n.language === "ar" && record?.name_ar
          ? record?.name_ar
          : record?.name,
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        i18n.language === "fr" && record?.surname
          ? record?.surname
          : record?.surname_ar,
    },
    {
      title: t("Nationnalité"),
      key: "Nationnalité",
      render: (_, record) => record?.nationality,
    },
    {
      title: t("Identifiant"),
      key: "Identifiant",
      render: (_, record) =>
        record?.nationality === "تونسية" ? record?.cin : record?.passport,
    },
    {
      title: t("Statut"),
      key: "Statut",
      render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor: record?.statut_couleur_background,
              color: record?.etat_color,
            }}
          >
            {t(record?.statut_apprenant)}
          </span>
        );
      },
    },
    {
      title: t("Actions"),
      key: "Actions",
      render: (_, record) => (
        <Space>
          <Dropdown
            menu={{
              items: [
                params?.state?.ligne_produit ===
                  import.meta.env
                    .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE && {
                  label: (
                    <Button
                      size="small"
                      block
                      // onClick={() => consulterPreInscrit(record, "consulter")}
                       onClick={() =>
                    {
                      setIsLoading(true)
                    navigate(`/sessionFormationHomologuee/detailsApprenant/${record?.id}`)
                    }}
                    >
                      {t("Consulter")}
                    </Button>
                  ),
                },

                 params?.state?.ligne_produit ===
                  import.meta.env
                    .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE && {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={(record?.id_statut_apprenant !== parseInt(import.meta.env.VITE_APP_ID_STATUT_APPRENANT_EN_FORMATION)) ||( params?.state?.id_etat_dossier_md5 ===
                                        import.meta.env
                                          .VITE_APP_ID_STATUS_BLOQUEE_SESSION_FORMATION_HOMOLOGUEE)}
                                           onClick={() => handleDemanderAttestation(record)}
                    
                    >
                      {t("Demander une attestation de présence ")}
                    </Button>
                  ),
                },

                 params?.state?.ligne_produit ===
                  import.meta.env
                    .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE && {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={(record?.id_statut_apprenant !== parseInt(import.meta.env.VITE_APP_ID_STATUT_APPRENANT_INDISPONIBLE)) ||
                        ( params?.state?.id_etat_dossier_md5 ===  import.meta.env
                                          .VITE_APP_ID_STATUS_BLOQUEE_SESSION_FORMATION_HOMOLOGUEE)}
                                           onClick={() => showDeleteConfirm(record)}
                    
                    >
                      {t("Supprimer l'apprenant")}
                    </Button>
                  ),
                },

                // {
                //   label: (
                //     <Button
                //       size="small"
                //       block

                //     >
                //       {t("Abandonner")}
                //     </Button>
                //   ),
                // },

                // {
                //   label: (
                //     <Button
                //       size="small"
                //       block
                //       disabled={
                //         !(
                //           (record?.documents?.content_diplome &&
                //             (params?.state?.ligne_produit ===
                //               import.meta.env
                //                 .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE ||
                //               params?.state?.ligne_produit ===
                //                 import.meta.env
                //                   .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_CONTINUE)) ||
                //           (record?.attestation_inscription &&
                //             params?.state?.ligne_produit ===
                //               import.meta.env
                //                 .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE)
                //         )
                //       }
                //       onClick={() => {
                //         setIsLoading(true);
                //         const filesToDownload =
                //           params?.state?.ligne_produit ===
                //             import.meta.env
                //               .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE ||
                //           params?.state?.ligne_produit ===
                //             import.meta.env
                //               .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_CONTINUE
                //             ? [
                //                 {
                //                   content: record?.documents?.content_diplome,
                //                   name: "diplôme",
                //                 },
                //               ]
                //             : [
                //                 // {
                //                 //   content:
                //                 //     record?.attestation_de_presence,
                //                 //   name: "attestation_présence",
                //                 // },
                //                 {
                //                   content: record?.attestation_inscription,
                //                   name: "attestation_inscription",
                //                 },
                //               ];

                //         filesToDownload.forEach((file) => {
                //           if (file.content) {
                //             window.open(file.content, "_blank");
                //           }
                //         });

                //         setIsLoading(false);
                //       }}
                //     >
                //       {t("Télécharger les documents")}
                //     </Button>
                //   ),
                // },
              ],
            }}
            trigger={["click"]}
          >
            <span style={{ cursor: "pointer" }}>
              <Space>
                {t("Liste")}
                <DownOutlined />
              </Space>
            </span>
          </Dropdown>
        </Space>
      ),
    },
  ];
  useEffect(() => {
    setIsLoading(true);
    async function fetchData() {
      axiosInstance
        .get(
          `${
            import.meta.env.VITE_APP_GEOPROD_API
          }/list_apprenant?id_affaire=${idDemande}`,
          {
            headers: {
              Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
                ?.Acces_Token,
            },
          }
        )
        .then((res) => {
          setData(res?.data?.message?.Data);
          setIsLoading(false);
        })
        .catch((error) => {
         notification.error({
            message: t("Erreur"),
            description: t(error?.response?.data?.message) || t("La requête n’a pas pu aboutir. Une alerte a été transmise à notre équipe technique qui s’en occupe déjà. Merci de réessayer un peu plus tard."),
        })
        
        
          setIsLoading(false);
          
        });
    }

    fetchData();
  }, [refresh]);

 
  const addApprenantsToSession = async (ids) => {
    setIsLoading(true)
    await addApprenantsToSessionHomologuee({
          list_apprenants: ids,
          id_session: idDemande,
        }).then((res)=>{
          setRefresh(!refresh);
          setIsLoading(false)
          
          notification.success({
              message: "Succès",
              description: t(
                res?.message
              ),
              duration: 0,
            });
    })
    .catch((error)=>
    {
    setIsLoading(false)

       notification.error({
        message: t("Erreur"),
        description: t(error?.data?.message) || t("La requête n’a pas pu aboutir. Une alerte a été transmise à notre équipe technique qui s’en occupe déjà. Merci de réessayer un peu plus tard."),
      });

    })

  };
  const handleOpenModal = async (session) => {

    setIsLoading(true);
    getListeDemandeurs(parseInt(params?.state?.id_session_formation)).then((res)=>
    {

    if (res?.message?.Data?.length <= 0) {
      setIsLoading(false);

      notification?.error({
        message: t("Erreur"),
        description: t(
          "La liste des demandeurs éligibles est vide. Pour ajouter des participants, merci de passer par l’interface de vérification de l’éligibilité."
        ),
        duration: 0,
      });
    } else {
      setIsLoading(false);

      // setSelectedSession(session);
      setDemandeurs(res?.message?.Data);
      setSelectedRowKeys([]);
      setModalVisible(true);
    }

    })
    .catch((error)=>
    {
      setModalVisible(false);
      setIsLoading(false);
          notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message) || t("La requête n’a pas pu aboutir. Une alerte a été transmise à notre équipe technique qui s’en occupe déjà. Merci de réessayer un peu plus tard."),
        })
        

    })

  };
  const handleAddParticipant = async () => {
    // if (data?.length === 20) {
    //   notification.error({
    //     message: t("Nombre maximal atteint"),
    //     description: t(
    //       "Vous ne pouvez pas ajouter d’autres apprenants à cette session de formation, car le nombre maximal autorisé dans le cadre de l’homologation a déjà été atteint."
    //     ),
    //     duration: 0,
    //   });
    // } else {

      const ids = selectedRowKeys?.map((id) => {
        const participant = demandeurs?.find((p) => p?.id === id);
        return participant?.id;
      });
      await addApprenantsToSession(ids);
      setModalVisible(false);
      setSelectedRowKeys([]);
  
  };
  return (
    <div>
  <Form form={form} layout="vertical" 
  >
      <Button
          className={classes.buttonCreate}
          onClick={() => navigate(-1)}
          style={{marginInline:"16px"}}

        >
          <CircleArrowLeft strokeWidth={1.25} />
          {t("Précédent")}
        </Button>
      <Card
        // title={
        //   params?.state?.ligne_produit ===
        //   import.meta.env
        //     .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE
        //     ? "Liste des apprenants"
        //     : "Liste des participants"
        // }
        extra={
          
          params?.state?.ligne_produit ===
            import.meta.env
              .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE &&
               (role === "directeur" || (role !== "directeur" && sessionStorage.getItem("director_identity") === "المستثمر نفسه"))
                && params?.state?.typedemande !== "historique" && (
            <Button
              type="primary"
              disabled={!check_disabled_btn_add_apprenant}
              onClick={() => handleOpenModal()}
            >
              {t("Ajouter des apprenants")}
            </Button>
          )
        }
      >
        <Table
          locale={{ emptyText: t("Aucune donnée") }}
        
          columns={columns}
          dataSource={data}
          className="ant-border-space"
          style={{ overflowX: "auto" }}
          pagination={true}
        />
      </Card>
      <Modal
        title="Ajouter des apprenants"
        open={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        width={800}
        okText="Ajouter"
        cancelText="Annuler"
        onCancel={() => setModalVisible(false)}
        onOk={handleAddParticipant}
        okButtonProps={{ disabled: selectedRowKeys.length === 0 }}
      >
        <Table
          rowSelection={{
            selectedRowKeys,
            onChange: (keys) => setSelectedRowKeys(keys),
          }}
          columns={[
            {
              title: t("Nom"),
              key: "Nom",
              render: (_, record) =>
                i18n.language === "ar" && record?.name_ar
                  ? record?.name_ar
                  : record?.name,
            },
            {
              title: t("Prénom"),
              key: "Prénom",
              render: (_, record) =>
                i18n.language === "fr" && record?.surname
                  ? record?.surname
                  : record?.surname_ar,
            },
            {
              title: t("Nationnalité"),
              key: "Nationnalité",
              render: (_, record) => record?.nationality,
            },
            {
              title: t("Identifiant"),
              key: "Identifiant",
              render: (_, record) =>
                record?.nationality === "تونسية"
                  ? record?.cin
                  : record?.passport,
            },
            {
              title: t("Statut"),
              key: "Statut",
              render: (_, record) => {
                return (
                  <span
                    style={{
                      padding: "4px 10px",
                      borderRadius: "5px",
                      fontSize: "12px",
                      backgroundColor: record?.statut_couleur_background,
                      color: record?.etat_color,
                    }}
                  >
                    {t(record?.statut_apprenant)}
                  </span>
                );
              },
            },
          ]}
          dataSource={demandeurs}
          rowKey="id"
          size="small"
        />
      </Modal>

   <Modal
      maskClosable={false}
          open={visibleModalDelete}
          footer={null}
          width={600}
          onCancel={() => setVisibleModalDelete(false)}
        >
          <h4>
            {
               t(
                `Êtes-vous sûr de vouloir supprimer l'apprenant ${selectedApprenant?.name} ${selectedApprenant?.surname}  ? Cette action est irréversible.`
              )
              }
          </h4>
          <Button
            type="primary"
            onClick={() => handleDeleteParticipant()}
          >
            {t("Oui")}
          </Button>
          <Button
            type="primary"
            style={{ marginInline: "15px" }}
            onClick={() => setVisibleModalDelete(false)}
          >
            {t("Non")}
          </Button>
        </Modal>
      <Modal
        maskClosable={false}
      destroyOnClose={true}
        title={t("Générer une attestation de présence")}
        open={attestationModalVisible}
        onCancel={() => {
          setAttestationModalVisible(false);
          form.resetFields();
        }}
        onOk={handleGenererAttestation}
        okText={t("Générer")}
        cancelText={t("Annuler")}
      >

          <p>{t("Veuillez choisir la langue de génération d'attestation")}</p>
          
          <Form.Item
            name="langue"
            label={t("Langue")}
            rules={[{ required: true, message: t("Veuillez sélectionner une langue") }]}
          >
            <Radio.Group>
              <Radio value="fr">{t("Français")}</Radio>
              <Radio value="ar">{t("Arabe")}</Radio>
            </Radio.Group>
          </Form.Item>
      </Modal>
        </Form>

    </div>
    
  );
};

export default ListeApprenants;
